import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RoomsEffects } from './rooms.effect';
import { RoomsFacade } from './rooms.facade';
import { roomsReducer } from './rooms.reducer';
import { RoomsService } from './rooms.service';

@NgModule({
  imports: [
    StoreModule.forFeature('rooms', roomsReducer),
    EffectsModule.forFeature([
      RoomsEffects,
    ]),
  ],
  providers: [
    RoomsService,
    RoomsFacade
  ]
})
export class RoomsModule {}
